import React from 'react';
class EnumRadioInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = {  
            value:this.props.value || 0
         }
         this.onChange= this.onChange.bind(this);
 
    }
    
    onChange(event)
    {
        let value=event.target.value;
        
        this.setState({
            value:value
        })
        
        this.props.onChange(value,event);

    }
    componentDidMount()
    {
        if(this.props.value)
        {
            this.state = {  
                value:this.props.value || 0
             }
        }

        console.log('value',this.props.value);
    }

    componentWillReceiveProps(newProps)
    {
        if(newProps.value)
        {
            this.state = {  
                value:newProps.value || 0
             }
        }
    }
    
    render() { 
        var keyArray = Object.keys(this.props.enumObj);
    
        return (  
                keyArray.map((key)=>{
                return <label><input name={this.props.name} type="radio" value={key} checked={this.state.value==key} onChange={(e)=>this.onChange(e)}/>{this.props.enumObj[key]}&nbsp;&nbsp;</label>
            })
        );
    }
}
 
export default EnumRadioInput;